import React, { useState, useEffect } from "react";
import "./invoiceDetails.css";

import ItemImage from "../../../images/test-image.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

import { useAuth } from "../../../contexts/AuthContext";

import { useNavigate, useParams, Link } from "react-router-dom";

import { toast } from "react-toastify";
import { useOrder } from "../../../contexts/OrderContext";
import Loader from "../../commonComponents/Loader/Loader";

export default function InvoiceDetails() {
  const [orderInfo, setOrderInfo] = useState();
  const [isFetching, setIsFetching] = useState(true);

  const { currentUser, logout } = useAuth();

  const navigate = useNavigate();

  const { dropZeros } = useOrder();

  const params = useParams();

  useEffect(() => {
    fetch("https://api.redfoxcafe.ir/v1/client/view-invoice/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify({
        invoiceId: params.invoiceId,
      }),
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          setOrderInfo(d.data);
          setIsFetching(false);
        } else if (d.status === "401") {
          toast.info(d.message);
          setIsFetching(false);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }, []);

  if (isFetching) return <Loader loading={isFetching} />;

  const items = orderInfo.InvocieDetails.map((val) => (
    <>
      <div className="invoice-cart-item" key={val.ProductID}>
        <img src={val.ProductPicture} alt="" className="invoice-item-image" />
        <div className="invoice-item-title">
          <span className="invoice-item-name">{val.ProductTitle}</span>
          {val.ProductMultiMode === "false" && (
            <span className="invoice-item-amount">تعداد : {val.Quantity}</span>
          )}
        </div>
        <div className="invoice-item-price-amount">
          <span className="invoice-item-price-number">
            {dropZeros(val.Price)}
          </span>
          هزار تومان
        </div>
      </div>
      <div className="invoice-cart-multi-items">
        {val.ProductMultiMode === "true"
          ? val.ProductMultiModeDetails.map((option) => (
              <div className="invoice-cart-multi-item">
                <span className="invoice-multi-name">{option.SubTitle}</span>
                <span className="invoice-multi-amount">
                  تعداد : {option.Quantity}
                </span>
                <div className="invoice-multi-price-amount">
                  <span className="invoice-multi-price-number">
                    {dropZeros(option.Price)}
                  </span>
                  هزار تومان
                </div>
              </div>
            ))
          : null}
      </div>
    </>
  ));

  return (
    <div className="invoice-details-main-container">
      <div className="invoice-details-header">
        <h2 className="invoice-details-text">جزئیات سفارش</h2>
        <Link to="/dashboard/orders" className="invoice-details-return">
          <FontAwesomeIcon icon={faChevronLeft} />
        </Link>
      </div>
      <div className="invoice-details-container">
        <div className="invoice-cart custom-scroll">{items}</div>
        <div className="invoice-details">
          <div className="invoice-price">
            <div className="shopping-list-price-item">
              <span className="shopping-list-price-title">
                مجموع بدون تخفیف :
              </span>
              <span className="shopping-list-price">
                <span className="shopping-list-price-amount">
                  {dropZeros(orderInfo.InvoicePrice) +
                    dropZeros(orderInfo.InvoiceDiscount)}
                </span>
                هزار تومان
              </span>
            </div>
            <div className="shopping-list-price-item">
              <span className="shopping-list-price-title">
                تخفیف برای شما :
              </span>
              <span className="shopping-list-price">
                <span className="shopping-list-price-amount">
                  {dropZeros(orderInfo.InvoiceDiscount)}
                </span>
                هزار تومان
              </span>
            </div>
            <div className="shopping-list-price-item highlighted">
              <span className="final-price">مجموع خرید شما :</span>
              <span className="shopping-list-price">
                <span className="shopping-list-price-amount">
                  {dropZeros(orderInfo.InvoicePrice)}
                </span>
                هزار تومان
              </span>
            </div>
          </div>
          <div className="invoice-status">{orderInfo.InvoiceStatus}</div>
        </div>
      </div>
    </div>
  );
}
